var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersonBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.74336 5.79965C6.69336 5.79465 6.63336 5.79465 6.57836 5.79965C5.38836 5.75965 4.44336 4.78465 4.44336 3.58465C4.44336 2.35965 5.43336 1.36465 6.66336 1.36465C7.88836 1.36465 8.88336 2.35965 8.88336 3.58465C8.87836 4.78465 7.93336 5.75965 6.74336 5.79965Z",
    stroke: "#444444",
    strokeWidth: 0.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.24344 7.64411C3.03344 8.45411 3.03344 9.7741 4.24344 10.5791C5.61844 11.4991 7.87344 11.4991 9.24844 10.5791C10.4584 9.7691 10.4584 8.44911 9.24844 7.64411C7.87844 6.72911 5.62344 6.72911 4.24344 7.64411Z",
    stroke: "#444444",
    strokeWidth: 0.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonBlack);
export default __webpack_public_path__ + "static/media/person-black.64a3d23b3e79d43d083c7183852f640c.svg";
export { ForwardRef as ReactComponent };